import api from "@/services/api/client";

export interface SynthesizeSpeechRequest {
  text: string;
  voice?: string;
}

function normalizeSpeechBlob(blob: Blob, contentType: string | undefined): Blob {
  const mime = contentType?.split(";")[0]?.trim() || "audio/mpeg";
  if (blob.type && blob.type !== "application/octet-stream") {
    return blob;
  }
  return new Blob([blob], { type: mime });
}

/** Synthesize text to speech via ani_api Azure Speech proxy. */
export async function synthesizeSpeech(
  request: SynthesizeSpeechRequest,
): Promise<Blob> {
  const response = await api.post<Blob>("/speech/synthesize", request, {
    responseType: "blob",
  });
  return normalizeSpeechBlob(
    response.data,
    response.headers["content-type"] as string | undefined,
  );
}
